/**
 * Utility functions for admin features
 */

const SUPER_ADMIN_EMAILS = [
  'dc@snnmanagement.com',
  'nc@snnmanagement.com'
];

/**
 * Check if a user is a super admin
 * Currently supports: dc@snnmanagement.com and nc@snnmanagement.com
 */
export function isSuperAdmin(userEmail: string | undefined | null): boolean {
  if (!userEmail) return false;
  const normalizedEmail = userEmail.toLowerCase();
  return SUPER_ADMIN_EMAILS.some(email => email.toLowerCase() === normalizedEmail);
}

/**
 * Get all super admin emails
 */
export function getSuperAdminEmails(): string[] {
  return [...SUPER_ADMIN_EMAILS];
}

/**
 * Get the super admin email (for backward compatibility)
 * Returns the first super admin email
 */
export function getSuperAdminEmail(): string {
  return SUPER_ADMIN_EMAILS[0];
}

